// extracted by mini-css-extract-plugin
export default {"text":"ErrorPage_text__JKPeZ","btn":"ErrorPage_btn__Uk9Zs","btn-primary":"ErrorPage_btn-primary__rNGsf"};